import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class PiratesHideout8PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.PIRATES_HIDEOUT8;
}

export default PiratesHideout8PoiTileEntity;
